export const pushCrispEvent = (eventName, data) => {
	try {
		if (window?.$crisp?.push) {
			window.$crisp.push(["set", "session:event", [[[eventName, data]]]])
		}
	} catch (error) {
		console.error(error)
	}
}
